







import { Vue, Component, Prop } from 'vue-property-decorator';
import { formatMoney, parseMoney } from '@/utils/format';

@Component
export default class MoneyInput extends Vue {
  @Prop({
    type: Number,
    required: true,
  })
  value!: number;

  get amountComputed() {
    return formatMoney(this.value);
  }

  set amountComputed(newAmount: string | null) {
    this.$emit('input', parseMoney(newAmount));
  }
}
